// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,300;1,500;0,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100%!important;
  position: fixed;
  top: 0; right: 0; left: 0; bottom: 0;
}

#root{
  position: fixed;
  top: 0; right: 0; left: 0; bottom: 0;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}


.tick-lines{
  stroke: #e6e6e6;
}
.point-plot-wrapper{
  align-items: center;
}
.team1-bar{
  fill: #469fee;
}
.lost-bar{
  fill: #e1e1e1;
}
.team2-bar{
  fill: #0f1745;
}
.score-text{
  text-anchor: middle;
  text-align: center;
  font-family: "RobotoBold";
  font-size: 12px;
  fill: #141414;
  font-weight: 800;
}
.infy-text{
  text-transform: uppercase;
}
#root{
  /* position: fixed; */
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  /* overflow-y: auto; */
}
.PercentageContent {
  /* box-shadow: 0 0 3px 5px rgb(255, 255, 255); */
  /* border-radius: 10px; */
  width: 60%;
  background: white;
  padding: 30px;
  z-index: 1;
  margin-top: 10px;
}

.Total {
  background: #E6ECF0 ;
  width: 100%;
  height: max-content;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

@media screen and (max-width: 780px) {
  .PercentageContent {
    width: 100%;
    padding: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;EACf,MAAM,EAAE,QAAQ,EAAE,OAAO,EAAE,SAAS;AACtC;;AAEA;EACE,eAAe;EACf,MAAM,EAAE,QAAQ,EAAE,OAAO,EAAE,SAAS;AACtC;;AAEA;EACE;aACW;AACb;;;AAGA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,OAAO;EACP,MAAM;EACN,SAAS;EACT,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,gDAAgD;EAChD,yBAAyB;EACzB,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;IACX,UAAU;EACZ;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,300;1,500;0,700&display=swap');\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  min-height: 100%!important;\n  position: fixed;\n  top: 0; right: 0; left: 0; bottom: 0;\n}\n\n#root{\n  position: fixed;\n  top: 0; right: 0; left: 0; bottom: 0;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n\n.tick-lines{\n  stroke: #e6e6e6;\n}\n.point-plot-wrapper{\n  align-items: center;\n}\n.team1-bar{\n  fill: #469fee;\n}\n.lost-bar{\n  fill: #e1e1e1;\n}\n.team2-bar{\n  fill: #0f1745;\n}\n.score-text{\n  text-anchor: middle;\n  text-align: center;\n  font-family: \"RobotoBold\";\n  font-size: 12px;\n  fill: #141414;\n  font-weight: 800;\n}\n.infy-text{\n  text-transform: uppercase;\n}\n#root{\n  /* position: fixed; */\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  /* overflow-y: auto; */\n}\n.PercentageContent {\n  /* box-shadow: 0 0 3px 5px rgb(255, 255, 255); */\n  /* border-radius: 10px; */\n  width: 60%;\n  background: white;\n  padding: 30px;\n  z-index: 1;\n  margin-top: 10px;\n}\n\n.Total {\n  background: #E6ECF0 ;\n  width: 100%;\n  height: max-content;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n@media screen and (max-width: 780px) {\n  .PercentageContent {\n    width: 100%;\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
